"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Media = (props) => {
    const { files, media, helper } = props;
    return (react_1.default.createElement(react_1.Fragment, null,
        files.length || media.length ? react_1.default.createElement("div", { className: "v2-horizontal-line" }) : null,
        react_1.default.createElement("div", { className: "media-wrapper" },
            media.length ? react_1.default.createElement("p", { className: "title" }, "Shared Media") : null,
            media.length ?
                react_1.default.createElement("div", { className: "images-container" }, media.map((el, i) => react_1.default.createElement("div", { key: i, className: 'img-container' },
                    react_1.default.createElement("img", { onClick: () => props.triggerSlider(i), src: helper.generatePreviewUrl(el), alt: "uploaded media" })))) : null,
            files.length && media.length ? react_1.default.createElement("div", { className: "v2-horizontal-line" }) : null,
            files.length ?
                react_1.default.createElement("div", { className: "file-container" },
                    react_1.default.createElement("p", { className: "title" }, "Shared Files"),
                    files.map((el, i) => react_1.default.createElement("a", { style: { cursor: 'pointer' }, onClick: () => helper.downloadFile(el), key: i, className: "file" }, el.name))) : null)));
};
exports.default = Media;
